import React from "react";
import { connect } from "react-redux";
import {setMatchmakingValue} from "../redux-actions/battle-actions";

class CrewTitle extends React.Component {

  launchEditCrewNameModal() {
    setMatchmakingValue({
      isCrewNameModalOption: true
    })
  }

  render() {
    const style = {
      display: "inline-block",
      textAlign: "center",
      padding: "1em",
      fontSize: "1.2em",
      textDecoration: "underline"
    };
    return (
      <div
        className={"pointer-on-hover"}
        style={style}
        onClick={this.launchEditCrewNameModal.bind(this)}
      >
        {this.props.crewName}
      </div>
    );
  }
}

export default connect((state, props) => {
  return {};
})(CrewTitle);



// WEBPACK FOOTER //
// ./src/b5-home/CrewTitle.js